import template from './query-toolbar.html';
import controller from './query-toolbar.controller';
import './query-toolbar.scss';

export default {
	controller,
	template,
	bindings: {
		disabled:  '<ngDisabled',
	},
	require:  {
		editor:      '^^queryEditor',
	},
};
